import React from "react";

import {
  Col,
  Row,
  Breadcrumb,
  BreadcrumbItem,
  Input,
  InputGroup,
  Button,
  InputGroupAddon,
  InputGroupText,
} from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSearch, faSpinner } from "@fortawesome/free-solid-svg-icons";

const Header = ({ searchText, onSearchWhitelist, onSearchClick, loading }) => {
  return (
    <Row className="mb-2 mb-xl-4">
      <Col xs="auto">
        <Breadcrumb>
          <BreadcrumbItem>Admin</BreadcrumbItem>

          <BreadcrumbItem active>Whitelist</BreadcrumbItem>
        </Breadcrumb>
      </Col>

      <Col xs="auto" className="ml-auto text-right mt-n1">
        <InputGroup className="mb-3">
          <InputGroupAddon addonType="prepend">
            <InputGroupText>
              <FontAwesomeIcon icon={faSearch} className="mr-2" />
              Search Whitelist
            </InputGroupText>
          </InputGroupAddon>
          <Input
            placeholder="Name Or Contact Info"
            name="searchWhitelist"
            value={searchText}
            onChange={onSearchWhitelist}
          />{" "}
          <Button
            color="primary"
            onClick={(e) => {
              e.stopPropagation();
              e.preventDefault();
              onSearchClick(e);
            }}
            disabled={loading}
          >
            Search
            {loading && <FontAwesomeIcon icon={faSpinner} className="ml-2" spin />}
          </Button>
        </InputGroup>
      </Col>
    </Row>
  );
};

export default Header;
